import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import { FieldBoundaryManagementMap } from './Map';
import { FieldBoundaryManagementTabs } from './Tabs';
import { Section } from '../Section';
import { Provider as FbmProvider } from './context';

export default function FieldBoundaryManagement() {
  return (
    <FbmProvider>
      <Section>
        <ResizablePanel
          topPanel={<FieldBoundaryManagementMap />}
          bottomPanel={<FieldBoundaryManagementTabs />}
        />
      </Section>
    </FbmProvider>
  );
}
